import React from 'react';
import _ from 'lodash';

import {
  SaveShippingServiceInput,
  ShippingServiceWidgetDocument,
  useSaveShippingServicesMutation,
  useShippingServiceWidgetQuery
} from 'generated/graphql';

import * as types from './types';



export interface IData {
  subsidiaryId: string;
  unmappedStrings: string[];
  formState: types.IFormState;
}

export function useQuery(storeId: string) {
  const tuple = useShippingServiceWidgetQuery({
    variables: {
      storeId
    }
  });

  return React.useMemo(
    () => {
      const mappedShippingServices = _.map(tuple.data?.store?.shippingServices ?? [], (node): types.IRow => ({
        id: node.id,
        thirdPartyAccount: node.thirdPartyAccount ? {
          id: node.thirdPartyAccount.id,
          displayName: ''
        } : null,
        requestedShippingService: node.requestedShippingService,
        shipItem: node.shipItem ? {
          id: node.shipItem.id,
          name: ''
        } : null
      }));

      // const notMapped = _.map(tuple.data?.notMappedRequestedShippingServices ?? [], (s): types.IRow => ({
      //   id: '',
      //   requestedShippingService: s,
      //   shipItem: null,
      //   thirdPartyAccount: null
      // }));

      const data: IData = {
        subsidiaryId: tuple.data?.store?.subsidiary?.id ?? '',
        unmappedStrings: _.map(tuple.data?.notMappedRequestedShippingServices ?? []),
        formState: {
          shippingServices: [
            ...mappedShippingServices
            // ...notMapped
          ]
        }
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useSaveShippingServices(storeId: string) {
  const [fnMutate, tuple] = useSaveShippingServicesMutation({
    refetchQueries: [
      {
        query: ShippingServiceWidgetDocument,
        variables: { storeId }
      }
    ]
  });

  const fnWrappedMutate = React.useCallback(
    (formState: types.IFormState) => {
      fnMutate({
        variables: {
          input: {
            storeId,
            services: _.map(formState.shippingServices, (service): SaveShippingServiceInput => ({
              id: service.id || undefined,
              requestedShippingService: service.requestedShippingService,
              shipItemId: service.shipItem?.id,
              thirdPartyAccountId: service.thirdPartyAccount?.id
            }))
          }
        }
      });
    },
    [fnMutate, storeId]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
